import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MessageModal from '@components/MessageModal';
import Spinner from '@components/Spinner';
import { DirectorySubscriber } from '@utils/backend-api/subscriber_directory';

import ProfilesList from './ProfilesList';

interface SubscribersProps {
  profiles?: DirectorySubscriber[];
  isLoadingSubscriberDirectory: boolean;
  descriptionField: string;
  currentUserId: number;
}

const Subscribers = ({
  profiles,
  isLoadingSubscriberDirectory,
  descriptionField,
  currentUserId,
}: SubscribersProps) => {
  const [messageUser, setMessageUser] = useState(null);

  const navigate = useNavigate();

  return (
    <div className="list-wrapper">
      {isLoadingSubscriberDirectory ? (
        <Spinner />
      ) : (
        <>
          <ProfilesList
            currentUserId={currentUserId}
            descriptionField={descriptionField}
            navigate={navigate}
            profiles={profiles}
            setMessageUser={setMessageUser}
          />
          <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />
        </>
      )}
    </div>
  );
};

export default Subscribers;
